import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useExpanded, useFlexLayout, useTable } from 'react-table';

import { noop } from 'ui-components/default-props/noop';

import style from './style.module.less';

const getRowId = (row) => {
  return row.id;
};

const ItemsTable = ({ items, columns, emptyRow = null, onColumnBlur = noop, onRowDelete = noop, disabled = false }) => {
  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } = useTable(
    {
      columns,
      data: items,
      onColumnBlur,
      onRowDelete,
      disabled,
      getRowId,
    },
    useFlexLayout,
    useExpanded,
  );

  const { getHeaderGroupProps, headers } = headerGroups[0];
  const showEmptyRow = !(rows?.length > 0);

  return (
    <div {...getTableProps()} className={style['items-table']}>
      <div {...getHeaderGroupProps()} className={style['header-row']}>
        {headers.map((column) => {
          const { key: headerCellKey, ...rest } = column.getHeaderProps();

          return (
            <div key={headerCellKey} className={classnames(style.cell, column.className)} id={column.id} {...rest}>
              {column.render('header')}
            </div>
          );
        })}
      </div>
      <div {...getTableBodyProps()}>
        {showEmptyRow
          ? emptyRow
          : rows.map((row) => {
              prepareRow(row);
              const { key: rowKey, ...rowProps } = row.getRowProps();

              return (
                <div key={rowKey} className={style['body-row']}>
                  <div {...rowProps}>
                    {row.cells.map((cell) => {
                      const { key: cellKey, ...cellProps } = cell.getCellProps();

                      return (
                        <div
                          key={cellKey}
                          aria-labelledby={cell.column.id}
                          className={classnames(style.cell, cell.column.className)}
                          {...cellProps}
                        >
                          {cell.render('cell')}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
};

ItemsTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      accessor: PropTypes.string.isRequired,
    }),
  ).isRequired,
  disabled: PropTypes.bool,
  emptyRow: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  onColumnBlur: PropTypes.func,
  onRowDelete: PropTypes.func,
};

export default ItemsTable;
